class BillfoldService {
  constructor ($q, $http, ngAuthSettings) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }
  
  getBranchesByThirdId(thirdId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFold(documentNumber, branchCode, limit , page) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST+
          '?terceroDocumentoNumero=' + documentNumber +
          '&codigoSucursal=' + branchCode +
          '&limit=' + limit +
          '&page=' + page +
          '&verDetalle=1',
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFolds(documentNumber, codigoSucursal, limit, page) {
    console.log(limit);
    console.log(page);
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST
            + '?terceroDocumentoNumero=' + documentNumber + '&codigoSucursal=' + codigoSucursal + '&limit=' + limit + '&page=' + page,
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  
  getBillFoldsByClient(documentNumber,codigoSucursal) {
    let data = JSON.stringify({reference: documentNumber , sucursal: codigoSucursal});

    var body = new FormData();
    body.append('formData', data);
    
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD_CLIENT.LIST,
        data: body,
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined },
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }
  getBillFoldsBranches(documentNumber, branchCodes, fecha_ini, fecha_fin) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST2,
        data : {
          'documentoTercero' : documentNumber,
          'branchCode' : branchCodes,
          'fecha_ini' : fecha_ini,
          'fecha_fin' : fecha_fin
        },
        cache : false
      }).then((response) => {
        resolve(response.data);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }

  getExportExcel(billfolds,nameClient,documentNumber){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.EXPORTEXCEL,
        data : {
          'billfolds' : billfolds,
          'nameClient' : nameClient,
          'documentNumber': documentNumber
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportPdf(billfolds,nameClient,documentNumber){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.EXPORT_PDF,
        data : {
          'billfolds' : billfolds,
          'nameClient': nameClient,
          'documentNumber': documentNumber
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', 
          'Accept': 'application/pdf'
        },
        cache : false,
        responseType: "blob"
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

BillfoldService.$inject = ['$q','$http', 'ngAuthSettings'];

export default BillfoldService;



/** WEBPACK FOOTER **
 ** ./www/components/reports/billfold/billfold.service.js
 **/